var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 30.0754C21.356 30.3733 20.6881 30.6282 20 30.8367V1.16332C20.6881 1.37175 21.356 1.62675 22 1.92464V30.0754ZM27 26.3925C26.3893 27.0678 25.72 27.6891 25 28.2484V3.75164C25.72 4.31086 26.3893 4.93216 27 5.60751V26.3925ZM30 21.4891C30.6463 19.7828 31 17.9327 31 16C31 14.0673 30.6463 12.2172 30 10.5109V21.4891ZM15.5 31.5C16.006 31.5 16.5064 31.4757 17 31.4284V0.571649C16.5064 0.524249 16.006 0.5 15.5 0.5C6.93959 0.5 0 7.43959 0 16C0 24.5604 6.93959 31.5 15.5 31.5Z",
    fill: "#7C37B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.f60eac4cd8be9f01baed0aa381d7f7fc.svg";
export { ForwardRef as ReactComponent };